import {
  IIkCardSelectableIconItem,
} from '@infomaniak/angular-common/src/components/ik-card-selectable-icon-item/ik-card-selectable-icon-item.interfaces';
import { translate } from '@ngneat/transloco';

export function getClientSpaceOwnPaymentMethods(): IIkCardSelectableIconItem[] {
  return [
    {
      icon: 'icon-card-double',
      title: translate('Vous reglez les commandes'),
      description: translate('Le partenaire utilisera vos moyens de paiement pour les commandes et renouvelement de vos produits.'),
    },
    {
      icon: 'icon-document',
      title: translate('Vous gerez la facturation'),
      description: translate('Les factures seront uniquement disponibles sur votre compte.'),
    },
  ];
}
